import {BuilderComponentGroupSlug} from "./types";
import {_t, getSlugByTranslation} from "./translations";
import {IWidgetResponse} from "../api/match-center";

let urlStructure: IUrlStructureObj[] = [];

export interface IUrlStructureObj {
  key: string,
  position: number|undefined,
  url: string,
}

export interface IHashLink {
  path: BuilderComponentGroupSlug|null,
  eventId: number|null
}

export enum dataAttributeKey {
  region = 'region',
  competition = 'competition',
  competitor = 'competitor'
}

export function getCompetitorLink( position: number): string | null{
  //pass position 1 for home team, position 2 for away team.
  if(urlStructure && position){
    const competitorUrl = urlStructure.find(e => e.key === dataAttributeKey.competitor && Number(e.position) === position);
    if(competitorUrl){
      return competitorUrl.url;
    }
  }
  return null;
}

export function getDataAttributeLink(attribute: dataAttributeKey): string | null{
  //pass attribute as 'region' or 'competition' to receive respective links if found in data attribute.
  if(urlStructure && attribute){
    const theAttr = urlStructure.find(e => e.key === attribute);
    if(theAttr){
      return theAttr.url;
    }
  }
  return null;
}

export function setUpUrlStructure(newUrlStructure: IUrlStructureObj[]): void {
  urlStructure = newUrlStructure;
}

export function getHashLink(widget: IWidgetResponse): IHashLink {
  let path: BuilderComponentGroupSlug|null = null
  let eventId: number|null = null

  let url = window.location.href
  let hashLink = url.split('/')

  let pathName = hashLink[hashLink.length-2]
  eventId = parseInt(hashLink[hashLink.length-1])
  if (isNaN(eventId)) {
    pathName = hashLink[hashLink.length-1]
    eventId = null
  }
  pathName = pathName.replace('_', ' ')

  let pathNameTranslationSlug = getSlugByTranslation(pathName)
  let builderComponentGroup = widget.builderComponentGroup.find((item) => {
    return item.name.toLowerCase() === pathNameTranslationSlug.toLowerCase()
  })

  if (builderComponentGroup)
    path = BuilderComponentGroupSlug[builderComponentGroup.slug.toLowerCase()] ?? null

  return {
    path: path,
    eventId: eventId
  }
}

export function setHashLinkUrl(tabName: string, eventId: number|null, widget: IWidgetResponse) {
  let url = window.location.href

  let translatedTabName = _t(tabName)
  translatedTabName = translatedTabName.toLowerCase().replace(' ', '_')

  if (url.indexOf('#/') !== -1) {
    let hashLink = getHashLink(widget)
    if (hashLink !== null && hashLink.path !== null) {
      let builderComponentGroup = widget.builderComponentGroup.find((item) => item.slug === hashLink.path)
      if (builderComponentGroup) {
        let translatedHashLinkPath = _t(builderComponentGroup.name.charAt(0).toUpperCase() + builderComponentGroup.name.slice(1))
        translatedHashLinkPath = translatedHashLinkPath.toLowerCase().replace(' ', '_')

        let hashLinkUri = `#/${translatedHashLinkPath}`
        if (hashLink.eventId !== null)
          hashLinkUri += `/${hashLink.eventId}`

        let newHashLinkUri = `#/${translatedTabName}`
        if (eventId !== null)
          newHashLinkUri += `/${eventId}`
        url = url.replace(hashLinkUri, newHashLinkUri)
      }
    } else url = addHashLinkToUrl(url, translatedTabName, eventId)
  } else {
    url = addHashLinkToUrl(url, translatedTabName, eventId)
  }

  window.location.replace(url)
}

function addHashLinkToUrl(url: string, hashLinkPath: string, eventId: number|null) {
  url = url.concat(`#/${hashLinkPath}`)
  if (eventId !== null)
    url = url.concat(`/${eventId}`)

  return url
}
